/***
 * @file:
 * @author: caojianping
 * @Date: 2021-05-24 18:59:18
 */
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { NoticeIconSelect, NoticeItem } from '../notify.model';

@Component({
  selector: 'dt-notice-icon-tab',
  templateUrl: './notice-icon-tab.component.html',
  styleUrls: ['./notice-icon-tab.component.scss'],
})
export class NoticeIconTabComponent {
  @Input() locale: any = {};
  @Input() data: NoticeItem;
  @Output() select = new EventEmitter<NoticeIconSelect>();
  @Output() clear = new EventEmitter<string>();

  onClick(item: NoticeItem) {
    this.select.emit({
      title: this.data.title,
      item,
    } as NoticeIconSelect);
  }

  onClear() {
    this.clear.emit(this.data.title);
  }
}
